export function localeFactory(i) {
    return i.get('$locale');
}

export const localeProvider = [
    { provide: '$locale', useFactory: localeFactory, deps: ['$injector'] },
];